export const ROUTES = {
  plans: (locale: string) => `/${locale}`,
  planDetail: (locale: string, slug: string) => `/${locale}/plans/${slug}`,
  userInfo: (locale: string) => `/${locale}/user-info`,
  compare: (locale: string) => `/${locale}/plans/compare`,
  configure: (locale: string) => `/${locale}/configure`,
  apply: (locale: string, planSlug: string) =>
    `/${locale}/apply?plan=${planSlug}`,
  forgotPassword: (locale: string) => `/${locale}/forgot-password`,
  login: (locale: string) => `/${locale}/auth/login`,
  register: (locale: string) => `/${locale}/auth/register`,
  dashboard: (locale: string) => `/${locale}/dashboard`,
  quotesHistory: (locale: string) => `/${locale}/dashboard/quotes-history`,
  quoteDetail: (locale: string, quoteId: string) =>
    `/${locale}/dashboard/quotes-history/${quoteId}`,

  // Dashboard sub-routes
  dashboardQuotes: (locale: string) => `/${locale}/dashboard/quotes`,
  dashboardPlans: (locale: string) => `/${locale}/dashboard/plans`,
  dashboardPlanDetail: (locale: string, slug: string) =>
    `/${locale}/dashboard/plans/${slug}`,
  dashboardPlanCreate: (locale: string) => `/${locale}/dashboard/plans/new`,
  dashboardPricing: (locale: string) => `/${locale}/dashboard/pricing`,
  dashboardPricingLoadings: (locale: string) =>
    `/${locale}/dashboard/pricing/loadings`,
  dashboardUsers: (locale: string) => `/${locale}/dashboard/users`,
  dashboardRoles: (locale: string) => `/${locale}/dashboard/users/roles`,

  // Pricing Engine sub-routes
  dashboardPricingPlanTiers: (locale: string) =>
    `/${locale}/dashboard/pricing/plan-tiers`,
  dashboardPricingRates: (locale: string) =>
    `/${locale}/dashboard/pricing/rates`,
  dashboardPricingLoadingConfig: (locale: string) =>
    `/${locale}/dashboard/pricing/loading-config`,
  dashboardPricingFees: (locale: string) => `/${locale}/dashboard/pricing/fees`,
  dashboardPricingConfiguration: (locale: string) =>
    `/${locale}/dashboard/pricing/configuration`,
  dashboardPricingOptionalBenefits: (locale: string) =>
    `/${locale}/dashboard/pricing/optional-benefits`,
  dashboardPricingAdjustments: (locale: string) =>
    `/${locale}/dashboard/pricing/adjustments`,
  dashboardPricingVersions: (locale: string) =>
    `/${locale}/dashboard/pricing/versions`,
  dashboardPricingPlanTierConfig: (locale: string) =>
    `/${locale}/dashboard/pricing/plan-tier-config`,
} as const
